import { toInputRow } from "@/features/dictionaries/attachDictionaryRows";
import { syncOwnedInputChoices } from "@/features/dictionaries/syncOwnedInputChoices";
import { supabaseClient } from "@/lib/supabase";
import type { InputKeyT, InputT } from "@patient-watch/types";
import { useMutation } from "@tanstack/react-query";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";

type UpsertInputT = Partial<InputT> & { input_id: string; input_key: InputKeyT };

export async function updateInput(input: UpsertInputT) {
    const data = await supabaseClient
        .from("inputs")
        .upsert(toInputRow(input))
        .eq("input_id", input.input_id)
        .eq("input_key", input.input_key)
        .select()
        .throwOnError()
        .single()
        .then((res) => res.data);
    await syncOwnedInputChoices(data);
    return data;
}

export const useUpdateInput = () => {
    const toastCopy = useToastCopy();
    return useMutation({
        mutationKey: ["input"],
        mutationFn: async (input: UpsertInputT) => {
            return await updateInput(input);
        },
        onError: () => {
            toast.error(toastCopy.errorCreatingDiaryLog);
        },
        onSuccess: (data) => {
            return data;
        },
    });
};
